import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reducers from '../rootReducer'
import { enableBatching } from 'core'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'

const enhancer = composeWithDevTools({
  /* options */
})(applyMiddleware(thunkMiddleware))
// const finalReducer = combineReducers({ ...reducers, routing: routerReducer });

// const createRootReducer = rds => combineReducers({ ...rds, routing: routerReducer })

export default function configureStore(initialState) {
  const store = createStore(enableBatching(reducers), initialState, enhancer)
  return store
}
